export const wizartSetupStyle = theme => ({
    root: {
        width: '650px',
        margin: 'auto'
    },
    contentAll: {
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)'
        },
        overflow: 'auto'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    contentStep:{
        paddingLeft:'50px',
        paddingRight:'50px'
    },
    footerStep:{
        paddingTop:'50px'
    },
    modal: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
})